import React, { useLayoutEffect, useRef, useState } from "react";
import Scrollbar from "smooth-scrollbar";

const ScrollbarWrapper = ({ id, options = {}, className, onSubmit, children }) => {
    const scrollbarRef = useRef(null);
    const [scrollActive, setScrollActive] = useState(true);
    const [hasVisibleTrack, setHasVisibleTrack] = useState(false);

    useLayoutEffect(() => {
        if (scrollbarRef?.current) {
            Scrollbar.init(scrollbarRef?.current, {
                damping: 0.1,
                thumbMinSize: 20,
                renderByPixels: true,
                continuousScrolling: "auto",
                alwaysShowTracks: true,
                delegateTo: null,
                plugins: {},
            });

            function setupScrollbar(options = {}) {
                const scrollbar = Scrollbar.get(scrollbarRef?.current);
                if (!scrollbar) return;

                if (options.removeXTrack && scrollbar.track.xAxis.element) {
                    scrollbar.track.xAxis.element.remove();
                }
                if (options.removeYTrack && scrollbar.track.yAxis.element) {
                    scrollbar.track.yAxis.element.remove();
                }

                let isScrolling;
                scrollbar.addListener(() => {
                    setScrollActive(true);

                    clearTimeout(isScrolling);
                    isScrolling = setTimeout(() => {
                        setScrollActive(false);
                    }, 200);
                });

                const toggleScrollbarClass = () => {
                    const tracks = scrollbarRef?.current?.querySelectorAll(`#${id} > .scrollbar-track`);

                    const hasVisibleTrack = tracks?.length > 0 && Array.from(tracks).some((track) => getComputedStyle(track).display === "block");

                    if (hasVisibleTrack) {
                        setHasVisibleTrack(true);
                    } else {
                        setHasVisibleTrack(false);
                    }
                };

                const tracks = scrollbarRef?.current?.querySelectorAll(`#${id} > .scrollbar-track`);
                const observer = new MutationObserver(() => {
                    toggleScrollbarClass();
                });

                tracks.forEach((track) => {
                    observer.observe(track, { attributes: true, attributeFilter: ["style"] });
                });

                if (!!options?.observeResize) {
                    const resizeTarget = document.querySelector(options.observeResize);
                    if (resizeTarget) {
                        const resizeObserver = new ResizeObserver(() => {
                            setTimeout(() => {
                                scrollbar.update();
                            }, 1000);
                            toggleScrollbarClass();
                        });
                        resizeObserver.observe(resizeTarget);
                    }
                }
            }

            setupScrollbar(options);
        }
    }, []);

    return onSubmit ? (
        <form
            ref={scrollbarRef}
            id={id}
            className={`${className} ${scrollActive ? "active-scroll" : ""} ${hasVisibleTrack ? "scrollbar-on" : ""}`}
            onSubmit={onSubmit}
            data-scrollbar
        >
            {children}
        </form>
    ) : (
        <div
            ref={scrollbarRef}
            id={id}
            className={`${className} ${scrollActive ? "active-scroll" : ""} ${hasVisibleTrack ? "scrollbar-on" : ""}`}
            data-scrollbar
        >
            {children}
        </div>
    );
};
export default ScrollbarWrapper;
